import {
  DUPLICATE_DMX_DEVICE_PRESETS,
  DUPLICATE_DMX_DEVICE_PRESETS_SUCCESSFUL,
  DUPLICATE_DMX_DEVICE_PRESETS_FAILED,
} from './actionTypes';

const initialState = {
  duplicateDmxDevicePresetsError: null,
  resultDmxDevicePresets: null,
  loadingDuplicateDmxDevicePresets: false,
};

const duplicateDevicePresets = (state = initialState, action) => {
  switch (action.type) {
    case DUPLICATE_DMX_DEVICE_PRESETS:
      state = { ...state, loadingDuplicateDmxDevicePresets: true, duplicateDmxDevicePresetsError: null };
      break;
    case DUPLICATE_DMX_DEVICE_PRESETS_SUCCESSFUL:
      state = {
        ...state,
        loadingDuplicateDmxDevicePresets: false,
        resultDmxDevicePresets: action.payload,
        duplicateDmxDevicePresetsError: null,
      };
      break;
    case DUPLICATE_DMX_DEVICE_PRESETS_FAILED:
      state = {
        ...state,
        resultDmxDevicePresets: null,
        loadingDuplicateDmxDevicePresets: false,
        duplicateDmxDevicePresetsError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default duplicateDevicePresets;
